module.exports = {
	"originSuggestions": [
		{
			"type": "airport",
			"airport": "Lynden Pindling Intl Airport",
			"iata": "NAS",
			"country_code": "BS",
			"city": "Nassau"
		},
		{
			"type": "airport",
			"airport": "Nashville Intl Airport",
			"iata": "BNA",
			"country_code": "US",
			"city": "Nashville"
		},
		{
			"type": "airport",
			"airport": "Smyrna Airport",
			"iata": "MQY",
			"country_code": "US",
			"city": "Nashville"
		},
		{
			"type": "airport",
			"airport": "Manchester Airport",
			"iata": "MHT",
			"country_code": "US",
			"city": "Nashua"
		},
		{
			"type": "city",
			"country": "United States",
			"country_code": "US",
			"city": "Nashville",
			"cityid_ppn": "800050426",
			"state_code": "TN"
		},
		{
			"type": "city",
			"country": "United States",
			"country_code": "US",
			"city": "Nashua",
			"cityid_ppn": "800049097",
			"state_code": "NH"
		},
		{
			"type": "city",
			"country": "United States",
			"country_code": "US",
			"city": "Nashville",
			"cityid_ppn": "800000663",
			"state_code": "IN"
		},
		{
			"type": "city",
			"country": "United States",
			"country_code": "US",
			"city": "Nason Creek",
			"cityid_ppn": "800558059",
			"state_code": "WA"
		}
	],
	"destinationSuggestions": [
		{
			"type": "airport",
			"airport": "Manchester Airport",
			"iata": "MHT",
			"country_code": "US",
			"city": "Nashua"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ../server/test/mocks/Location_Suggestions.json
// module id = 204
// module chunks = 0